
import React, { RefObject } from 'react';
import { Search, X, ArrowRight } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

interface SearchInputProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  onSearchSubmit: () => void;
  onClearSearch: () => void;
  onFocus: () => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
  inputRef: RefObject<HTMLInputElement>;
  isMobile: boolean;
}

const SearchInput: React.FC<SearchInputProps> = ({
  searchQuery,
  onSearchChange,
  onSearchSubmit,
  onClearSearch,
  onFocus,
  onKeyDown,
  inputRef,
  isMobile
}) => {
  return (
    <form 
      onSubmit={(e) => { e.preventDefault(); onSearchSubmit(); }} 
      className="relative" 
      role="search"
      aria-label="Search for treks"
    >
      <div className="relative group">
        <Input
          ref={inputRef}
          type="text"
          placeholder="Search for a trek..."
          className="w-full pl-12 pr-14 py-7 rounded-full border-nature-300/80 dark:border-nature-700/50 shadow-md focus:ring-2 focus:ring-nature-500/50 dark:focus:ring-nature-500/30 bg-background transition-all duration-300 group-hover:shadow-lg"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          onFocus={onFocus}
          onKeyDown={onKeyDown}
          autoComplete="off"
          aria-label="Search input"
          aria-autocomplete="list"
        />
        <div className="absolute left-5 top-1/2 -translate-y-1/2 transition-transform duration-300 group-hover:scale-110">
          <Search className="h-5 w-5 text-trek-olive dark:text-trek-sand/70" aria-hidden="true" />
        </div>

        {searchQuery && (
          <button 
            type="button"
            onClick={onClearSearch}
            className="absolute right-[70px] top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground focus:outline-none focus:ring-2 focus:ring-nature-500/50 rounded-full p-1 transition-colors"
            aria-label="Clear search"
          >
            <X className="h-5 w-5" aria-hidden="true" />
          </button>
        )}

        <Button 
          className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full bg-trek-olive hover:bg-trek-forest text-white shadow-sm transition-all duration-300 group-hover:shadow-md"
          onClick={onSearchSubmit}
          type="submit"
          aria-label={isMobile ? "Search" : "Search Treks"}
        >
          {isMobile ? <ArrowRight className="h-4 w-4" aria-hidden="true" /> : "Search Treks"}
        </Button>
      </div>
    </form>
  );
};

export default SearchInput;
